<template>
    <component :is="layout">
        <router-view />
    </component>
    <Toast />
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { Toast } from 'primevue'
    import { useToast } from 'primevue/usetoast'

    import Default from '@/layouts/Default.vue'
    import Blank   from '@/layouts/Blank.vue'
    import { setToast } from '@/libs/toast'

    const route = useRoute()

    const layouts = { Default, Blank }
    const layout  = computed(() => layouts[(route.meta.layout as keyof typeof layouts) ?? 'Default'])

    setToast(useToast())
</script>
